export default __webpack_public_path__ + "static/media/flightTakeOffIcon.2b1b24d7.svg";